import React, { useEffect, useMemo, useState } from 'react';

function getLocalStorageBoolean(key, defaultValue) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return raw === '1' || raw === 'true';
  } catch {
    return defaultValue;
  }
}

function setLocalStorageBoolean(key, value) {
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch {
    // ignore
  }
}

function BeginnerTips({
  enabled,
  hasVideo,
  produtos,
  video,
  setVisivel
}) {
  const [collapsed, setCollapsed] = useState(() =>
    getLocalStorageBoolean('beginnerTipsCollapsed', false)
  );

  useEffect(() => {
    setLocalStorageBoolean('beginnerTipsCollapsed', collapsed);
  }, [collapsed]);

  const totalProdutos = Array.isArray(produtos) ? produtos.length : 0;

  const checks = useMemo(() => {
    const hasProducts = totalProdutos > 0;
    const hasTheme = Boolean(video?.background) || Boolean(video?.selo);
    const hasLogo = Boolean(video?.logo);
    const hasMusic = Boolean(video?.musica_url);

    const hasIntro = Boolean(video?.intro_audio);
    const hasProductAudio = Array.isArray(produtos)
      ? produtos.some((p) => Boolean(p?.audio))
      : false;
    const hasNarration = hasIntro || hasProductAudio;

    return [
      { key: 'produtos', label: `Adicionar produtos (${totalProdutos}/10)`, ok: hasProducts, goTo: 'produtos' },
      { key: 'temas', label: 'Escolher um tema', ok: hasTheme, goTo: 'temas' },
      { key: 'personalizar', label: 'Adicionar sua logo', ok: hasLogo, goTo: 'personalizar' },
      { key: 'musicas', label: 'Escolher música de fundo', ok: hasMusic, goTo: 'musicas' },
      { key: 'locucao', label: 'Gerar locução', ok: hasNarration, goTo: 'locucao' },
      { key: 'baixar', label: 'Baixar o vídeo (quando estiver pronto)', ok: false, goTo: null }
    ];
  }, [produtos, totalProdutos, video]);

  if (!enabled) return null;

  if (collapsed) {
    return (
      <button
        type="button"
        className="beginner-tips-collapsed"
        onClick={() => setCollapsed(false)}
        aria-label="Abrir dicas"
        title="Abrir dicas"
      >
        <i className="fa-solid fa-circle-question" aria-hidden="true" />
      </button>
    );
  }

  return (
    <aside className="beginner-tips" aria-label="Dicas para iniciantes">
      <div className="beginner-tips__header">
        <div className="beginner-tips__title">
          <i className="fa-solid fa-wand-magic-sparkles" aria-hidden="true" />
          <span>Dicas rápidas</span>
        </div>
        <div className="beginner-tips__actions">
          <button
            type="button"
            className="beginner-tips__icon"
            onClick={() => setCollapsed(true)}
            aria-label="Minimizar"
            title="Minimizar"
          >
            <i className="fa-solid fa-minus" aria-hidden="true" />
          </button>
        </div>
      </div>

      {!hasVideo ? (
        <div className="beginner-tips__body">
          <p className="beginner-tips__text">
            Para começar, crie um novo vídeo e depois siga o passo a passo.
          </p>
        </div>
      ) : (
        <div className="beginner-tips__body">
          <p className="beginner-tips__text">
            Siga esta ordem para chegar no download mais rápido:
          </p>

          <ol className="beginner-tips__list">
            {checks.map((item) => (
              <li key={item.key} className={item.ok ? 'ok' : ''}>
                <span className="dot" aria-hidden="true">
                  {item.ok ? <i className="fa-solid fa-check" /> : <i className="fa-regular fa-circle" />}
                </span>
                <span className="label">{item.label}</span>
                {item.goTo && (
                  <button
                    type="button"
                    className="go"
                    onClick={() => setVisivel(item.goTo)}
                  >
                    Abrir
                  </button>
                )}
              </li>
            ))}
          </ol>

          <div className="beginner-tips__footer">
            <button
              type="button"
              className="beginner-tips__primary"
              onClick={() => setVisivel('produtos')}
            >
              Começar pelos produtos
            </button>
          </div>
        </div>
      )}
    </aside>
  );
}

export default BeginnerTips;
